<template>
  <v-container class="py-0">
    <v-row
      :class="`rounded-lg border--${color} mb-2`"
      v-bind:style="{
        color: $vuetify.theme.themes.light[color] + ' !important',
        backgroundColor: getColor($vuetify.theme.themes.light[color], 0.05)
      }"
    >
      <v-col class="my-auto">
        <span class="font-weight-medium mr-2" v-if="label"> {{ label }}: </span>
        <slot></slot>
      </v-col>
      <v-spacer class="limited-spacer"> </v-spacer>
      <v-col :cols="$vuetify.breakpoint.mdAndUp ? 'auto' : '12'">
        <v-btn
          color="performance"
          dark
          @click="$emit('click')"
          v-if="buttonText"
          block
        >
          {{ buttonText }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "SingleListItem",
  props: {
    color: { type: String, default: "secondary" },
    label: { type: String },
    buttonText: { type: String }
  }
};
</script>
